/* eslint-disable max-len */
import { DeleteOutlined, DownOutlined } from '@ant-design/icons';
import { Button, Dropdown, Menu, Space } from 'antd';
import { useTranslation } from 'react-i18next';
import { type FinderVehicleManagementModuleSpecsFragment } from '../../../../api/fragments/FinderVehicleManagementModuleSpecs';
import { type PermissionValues } from '../../../../utilities/hasPermissions';
import useDeleteModule from '../useDeleteModule';

export type FinderVehicleManagementModuleActionProps = {
    module: FinderVehicleManagementModuleSpecsFragment;
    permissions: Pick<PermissionValues, 'hasDeletePermission'>;
};

const FinderVehicleManagementModuleAction = ({ module, permissions }: FinderVehicleManagementModuleActionProps) => {
    const { t } = useTranslation(['finderVehicleManagementModuleDetails', 'moduleDetails']);
    const deleteModule = useDeleteModule(module.id);
    const { hasDeletePermission } = permissions;

    const items = [
        hasDeletePermission && {
            label: t('finderVehicleManagementModuleDetails:actions.delete'),
            key: 'delete',
            icon: <DeleteOutlined />,
            onClick: deleteModule,
            danger: true,
        },
    ].filter(Boolean);

    if (!items.length) {
        return null;
    }

    return (
        <Dropdown overlay={<Menu items={items} />}>
            <Button type="primary">
                <Space>
                    <span>{t('finderVehicleManagementModuleDetails:actions.label')}</span>
                    <DownOutlined />
                </Space>
            </Button>
        </Dropdown>
    );
};

export default FinderVehicleManagementModuleAction;
